// src/data/contactSectionComponentData.js (example)
const contactSectionComponent = {
  heading: "The Bottom Line is<span> We Get it Done!</span>",
  skilledTalent: {
    title: "Skilled Talent Network",
    description: "Our team consists of highly experienced professionals.",
  },
  swiftTurnaround: {
    title: "Swift Turnaround",
    description:
      "We provide fast & efficient solutions despite time constraints.",
  },
  costEffective: {
    title: "Cost-effective Solutions",
    description:
      "We deliver high-quality services that maximize your budget’s potential.",
  },
  innovationDriven: {
    title: "Innovation-Driven Development",
    description:
      "We focus on delivering cutting-edge, innovative, & tailored solutions.",
  },
  contactEmails: [
    {
      text: "hello@bitsclan.com",
      href: "mailto:hello@bitsclan.com",
      icon: "/images/SVG/email-icon.png",
    },
  ],
  helloEmails: [
    {
      text: "hello@bitsclan.com",
      href: "hello@bitsclan.com",
      icon: "/images/SVG/email-icon.png",
    },
  ],
  contactPhones: [
    {
      text: "+1 315 666 8052",
      href: "tel:+13156668052",
      icon: "/images/SVG/Phone.svg",
    },
  ],
  recaptchaSiteKey: "6LduktkqAAAAAAG-TJxQPKptt1p5F4l_FYqYqNgv",
  thankYouVideo: "/videos/thankyou-vedio.mp4",
  calendlyLink: "https://calendly.com/bitsclan-it/30min?month=2025-01",
  servicesOptions: [
    { value: "Software Development", label: "Software Development" },
    { value: "UI/UX", label: "UI/UX" },
    { value: "QA", label: "QA" },
    { value: "Integration", label: "Integration" },
    { value: "Maintenance", label: "Maintenance" },
    { value: "Consultancy", label: "Consultancy" },
  ],
  formLabels: {
    fullName: "Full Name",
    email: "Email",
    phoneNumber: "Phone Number",
    services: "Services",
    aboutProject: "Tell us about your project",
    attachFile: "Attach file (Optional)",
    submitButton: "Submit",
    // requiredSymbol: "*",
  },

  // CONTACT US PAGE FORM DATA

  contactUsFormStaticData: {
    firstName: {
      label: "Name",
      placeholder: "Enter your name here",
    },
    phone: {
      label: "Phone Number",
      placeholder: "Enter your phone number here",
    },
    email: {
      label: "Email",
      placeholder: "Enter your email here",
    },
    companyName: {
      label: "Company Name",
      placeholder: "Enter your company name here",
    },
    CountryName: {
      label: "Country Name",
      placeholder: "Enter your country name here",
    },
    aboutProject: {
      label: "About Your Project",
      placeholder: "Tell us more about your project",
    },
    nda: {
      label: "Do You Need an NDA first?",
      options: ["Yes", "No"],
    },
    services: {
      placeholder: "Services",
      label: "I'm Looking For",
    },
    submitButton: {
      buttonText: "Request Free Estimate",
      loadingText: "Loading...",
    },
  },

  servicesArray: [
    {
      value: "Web Application Development",
      label: "Web Application Development",
    },
    {
      value: "AI Development",
      label: "AI Development",
    },
    {
      value: "Custom Development",
      label: "Custom Development",
    },
    {
      value: "Mobile App Development",
      label: "Mobile App Development",
    },
    {
      value: "DevOps Services",
      label: "DevOps Services",
    },
    // {
    //   value: "Quality Assurance Services",
    //   label: "Quality Assurance Services",
    // },
    // {
    //   value: "Data Analytics",
    //   label: "Data Analytics",
    // },
    {
      value: "BlockChain Development",
      label: "BlockChain Development",
    },
    // {
    //   value: "Cyber Security",
    //   label: "Cyber Security",
    // },
  ],
};

export default contactSectionComponent;
